import 'src/styles/ui/resource-card-alt.css';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * ResourceCardAlt Component - Alternative card layout for displaying structured information
 * Features a header with title and a body with flexible content (typically rows of data)
 *
 * @param {Object} props
 * @param {string} props.title - Card header title
 * @param {React.ReactNode} props.children - Card body content
 * @param {string} props.className - Additional CSS classes
 */
const ResourceCardAlt = ({ title, children, className, ...props }) => {
  const cardClasses = classNames('resource-card-alt', className);

  return (
    <div className={cardClasses} {...props}>
      <div className='resource-card-alt__header'>
        <h3 className='resource-card-alt__title'>{title}</h3>
      </div>
      {children && <div className='resource-card-alt__body'>{children}</div>}
    </div>
  );
};

ResourceCardAlt.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

ResourceCardAlt.defaultProps = {
  children: null,
  className: '',
};

export default ResourceCardAlt;
